import { render, staticRenderFns } from "./ProductTemplateBuilderItemRemove.vue?vue&type=template&id=a551d4c8"
import script from "./ProductTemplateBuilderItemRemove.vue?vue&type=script&lang=js"
export * from "./ProductTemplateBuilderItemRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports